<template>
  <div class="fixed top-4 right-4 z-50 max-w-md">
    <div
      class="bg-white rounded-lg shadow-lg border-l-4 p-4 transition-all duration-300"
      :class="borderColorClass"
    >
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <component :is="iconComponent" class="h-6 w-6" :class="iconColorClass" />
        </div>
        <div class="ml-3 flex-1">
          <h3 class="text-sm font-medium" :class="titleColorClass">
            {{ notification.title }}
          </h3>
          <div class="mt-1 text-sm text-gray-600">
            {{ notification.message }}
          </div>
        </div>
        <button
          @click="$emit('close')"
          class="ml-3 flex-shrink-0 text-gray-400 hover:text-gray-600"
        >
          <XMarkIcon class="h-5 w-5" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';

const props = defineProps({
  notification: {
    type: Object,
    required: true,
  },
});

defineEmits(['close']);

const iconComponent = computed(() => {
  const icons = {
    success: CheckCircleIcon,
    error: XCircleIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon,
  };
  return icons[props.notification.type] || InformationCircleIcon;
});

const borderColorClass = computed(() => {
  const colors = {
    success: 'border-green-500',
    error: 'border-red-500',
    warning: 'border-yellow-500',
    info: 'border-blue-500',
  };
  return colors[props.notification.type] || 'border-blue-500';
});

const iconColorClass = computed(() => {
  const colors = {
    success: 'text-green-500',
    error: 'text-red-500',
    warning: 'text-yellow-500',
    info: 'text-blue-500',
  };
  return colors[props.notification.type] || 'text-blue-500';
});

const titleColorClass = computed(() => {
  const colors = {
    success: 'text-green-800',
    error: 'text-red-800',
    warning: 'text-yellow-800',
    info: 'text-blue-800',
  };
  return colors[props.notification.type] || 'text-blue-800';
});
</script>
